import { useMemo } from 'react'
import {
  createImageItemListStateAtom,
  MediaSelectPreviewPanelItemListContext,
  MediaSelectPreviewPanelUploadProvider,
} from '../Media/MediaSelectPreviewPanel/context'
import {
  ImageItemsSourceContextProvider,
  TrainLoraContextProvider,
  TrainLoraDatasetContextProvider,
  TrainLoraSubmitContextProvider,
} from './context'
import TrainLoraDatasetDisplay from './TrainLoraDatasetDisplay'
import TrainLoraParameters, { TrainLoraSubmitBar } from './TrainLoraParameters'

export default function TrainLoraContent() {
  const stateAtom = useMemo(createImageItemListStateAtom, [])
  return (
    <ImageItemsSourceContextProvider>
      <MediaSelectPreviewPanelItemListContext.Provider value={stateAtom}>
        <TrainLoraContextProvider>
          <TrainLoraDatasetContextProvider>
            <TrainLoraSubmitContextProvider>
              <div
                id="train-lora-form-top"
                className="scroll-mt-24 flex flex-col lg:grid lg:grid-cols-[3fr_2fr] gap-6 bg-background w-full max-w-screen-2xl mx-auto px-5 pt-5 pb-24"
              >
                <div className="order-1 min-w-0 lg:h-[calc(100vh-120px)] lg:sticky lg:top-[60px]">
                  <MediaSelectPreviewPanelUploadProvider>
                    <TrainLoraDatasetDisplay />
                  </MediaSelectPreviewPanelUploadProvider>
                </div>
                <div className="order-2 min-w-0">
                  <TrainLoraParameters />
                </div>
              </div>
              <TrainLoraSubmitBar />
            </TrainLoraSubmitContextProvider>
          </TrainLoraDatasetContextProvider>
        </TrainLoraContextProvider>
      </MediaSelectPreviewPanelItemListContext.Provider>
    </ImageItemsSourceContextProvider>
  )
}
